import { z } from "zod";

// The agent's ordered turn status as the daemon stamps it on agent_stream, agent_status and
// list_agents rows (knowledge/126 step 2b). The one definition on this side of the wire.
export const AgentTurnStatusSchema = z.object({
  statusRev: z.number().int().positive(),
  lifecycle: z.enum(["running", "idle"]),
  turnId: z.string().nullable(),
  turnSession: z.string().nullable(),
});

export type AgentTurnStatus = z.infer<typeof AgentTurnStatusSchema>;

// The frame's turn record (#3754): `turnRecord`, else the legacy `turnStatus` an older daemon sends.
export function wireTurnRecord(frame: { turnRecord?: unknown; turnStatus?: unknown }): unknown {
  return frame.turnRecord ?? frame.turnStatus;
}
